<template>
  <b-card>
    <b-form>
      <fieldset :disabled="loading">
        <b-form-group id="organizationNumber-group" :label="$t('organizationNumber')" label-for="organizationNumber">
          <b-form-input size="sm" id="organizationNumber" type="text" v-model="filter.organizationNumber" :disabled="isActiveProfileSet" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="productName-group" :label="$t('productName')" label-for="productName">
          <b-form-input size="sm" id="productName" type="text" v-model="filter.productName" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="ean-group" :label="$t('ean_isbn')" label-for="ean">
          <b-form-input size="sm" id="ean" type="text" v-model="filter.ean" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" class="float-right" v-on:click="resetFilter">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>
        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>
      </fieldset>
    </b-form>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UsageFilter',
    extends: BaseComponent,

    computed: {
      ...mapGetters('usage', ['filter', 'paging', 'loading']),
      ...mapState('usage', { filter: state => state.filter }),
      ...mapGetters('sessionStorage', ['isActiveProfileSet', 'activeProfile']),
    },
    methods: {
      onKeyup (event) {
        if (event.which === 13) {
          this.updateLicenses()
        }
      },
      resetFilter () {
        this.$store.dispatch('usage/resetFilter')
      },
      updateLicenses () {
        this.$store.dispatch('usage/getLicenses')
      },
    },
    watch: {
      'paging.perPage': function () {
        this.updateLicenses()
      },
      'paging.currentPage': function () {
        this.updateLicenses()
      },
      'isActiveProfileSet': function () {
        this.updateLicenses()
      },
    },
  }
</script>
